<template>
  <div class="videopage bg" >
    <v-nav></v-nav>
    <mode v-if="loadMode" class="modeapp"></mode>
    <div class="photo_content">
      <div class="swiper">
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="item in photoList">
            <div class="photo">
              <div class="photo_box">
                <img :src="item.image" :alt="item.name">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import mode from '@/components/bg/mode'
  import Swiper from '../../../public/swiper/swiper-bundle.min';
    export default {
        name: "photo",
        components:{
          mode
        },
        data() {
            return {
              photoList:[],
              currentUrl:'',
              currentUrlImgName:'',
              loadMode:true,
            }
        },
        mounted() {
          this.getList()
        },
        methods: {
          getList(){
            this.$http({
              url: '/Photo/list',
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              data: {ajax:1}
            }).then((res) => {
              this.loadMode=false
              if(res.data.code==0){
                this.photoList=res.data.data
                var swiper = new Swiper(".swiper", {
                  initialSlide :0,		//轮播开始位置
                  observer:true,			//轮播元素为内部动态添加必须加此 修改swiper自己或子元素时，自动初始化swiper
                  observeParents:true,	//轮播元素为内部动态添加必须加此 修改swiper的父元素时，自动初始化swiper
                  slidesPerView: 1,
                  spaceBetween: 30,
                  pagination: {
                    el: ".swiper-pagination",
                    bulletClass : 'swiper-pagination-bullet bullColor',
                    bulletActiveClass: 'bullet-active-current',
                  },
                });
              }else{
                this.$layer.msg(res.data.msg)
              }
            })
            .catch((error) => {
              // error
              this.$layer.msg('网络错误，请稍后重试')
              this.loadMode=false
              console.log(error)
            })
          }
        }
    }
</script>

<style scoped lang="scss">
  .bg{
    background: url("../../assets/images/phone/bg.jpg")no-repeat left bottom;
    position: fixed;
    top:0;
    min-height: 100%;
    left:0;
    right:0;
    bottom:0;
    overflow: hidden;
    background-size:100% 100%;
  }
  .photo_content{
    height:calc(100% - 1rem);
    .swiper{
      height:100%;
      .swiper-wrapper{
        height:100%;
      }
    }
    .swiper-slide{
      width:100%;
      height:100%;
      .photo{
        height:100%;
        display: flex;
        align-items: center;
        .photo_box{
          width:100%;
          max-height:100%;
          position: relative;
          img{
            width:100%;
            max-height: 100%;
            object-fit: cover;
          }
        }

      }

    }
  }
</style>



// WEBPACK FOOTER //
// src/views/m/photo.vue